// Floor endpoints nested under site.

import { request, type ApiResponse } from "../client";
import type { FloorCreate, FloorOut } from "../types/floor";

export const floors = {
  list: (
    accountSlug: string,
    tenantSlug: string,
    siteSlug: string,
  ): Promise<ApiResponse<FloorOut[]>> =>
    request<FloorOut[]>(
      "GET",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}/sites/${encodeURIComponent(siteSlug)}/floors`,
    ),

  get: (
    accountSlug: string,
    tenantSlug: string,
    siteSlug: string,
    floorSlug: string,
  ): Promise<ApiResponse<FloorOut>> =>
    request<FloorOut>(
      "GET",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}/sites/${encodeURIComponent(siteSlug)}/floors/${encodeURIComponent(floorSlug)}`,
    ),

  create: (
    accountSlug: string,
    tenantSlug: string,
    siteSlug: string,
    body: FloorCreate,
  ): Promise<ApiResponse<FloorOut>> =>
    request<FloorOut>(
      "POST",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}/sites/${encodeURIComponent(siteSlug)}/floors`,
      body,
    ),
};
